<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RollingCounter',
  props: {
    value: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      displayValue: 0,
      animationFrame: null as number | null,
      isInitialLoad: true,
    }
  },
  watch: {
    value: {
      handler(newValue: number) {
        if (this.isInitialLoad) {
          this.isInitialLoad = false
          this.displayValue = newValue
          return
        }

        const startValue = this.displayValue
        const endValue = newValue
        const startTime = performance.now()
        const difference = endValue - startValue

        const animate = (currentTime: number) => {
          const elapsed = currentTime - startTime
          const progress = Math.min(elapsed / this.duration, 1)

          // Easing function to start slow and speed up
          const easeInQuad = (t: number) => t * t

          // Calculate step size based on progress
          // Early in animation: smaller steps
          // Later in animation: larger steps
          const currentProgress = easeInQuad(progress)
          const newValue = Math.round(startValue + difference * currentProgress)

          this.displayValue = newValue

          if (progress < 1) {
            this.animationFrame = requestAnimationFrame(animate)
          } else {
            this.displayValue = endValue
          }
        }

        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame)
        }

        this.animationFrame = requestAnimationFrame(animate)
      },
      immediate: true,
    },
  },
  beforeUnmount() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }
  },
})
</script>

<template>
  <span>{{ $n(displayValue, 'number') }}</span>
</template>
